import { render, staticRenderFns } from "./Analyses.vue?vue&type=template&id=b0cfea48"
import script from "./Analyses.vue?vue&type=script&lang=js"
export * from "./Analyses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports